export function validatePhone(phone?: string): boolean {
  if (!phone) return false

  // Remove formatação para contar dígitos
  const digitsOnly = phone.replace(/\D/g, '')

  // Celular: 11 dígitos com 9 no início do número
  const cellPhoneRegex = /^\(\d{2}\)\s9\d{4}-\d{4}$/

  // Telefone fixo: 10 dígitos
  const landlineRegex = /^\(\d{2}\)\s\d{4}-\d{4}$/

  // Valida automaticamente baseado no padrão
  if (digitsOnly.length === 11) {
    return cellPhoneRegex.test(phone)
  }

  if (digitsOnly.length === 10) {
    return landlineRegex.test(phone)
  }

  return false
}
